// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3PP_e","row":"Node_row__2NC3N","label":"Node_label__TYteq","footer":"Node_footer__15vrK"};